import { errorTrackingTransport } from "@/src/config/errorTrackingTransport.js";

export default {
  // Workspace initialization
  async getInitStatus() {
    const res = await errorTrackingTransport.get("/workspace/init/status");
    return res.data;
  },

  async initializeWorkspace() {
    const res = await errorTrackingTransport.post("/workspace/init");
    return res.data;
  },

  // Services
  async listServices() {
    const res = await errorTrackingTransport.get("/services");
    return res.data;
  },

  async getService(id) {
    const res = await errorTrackingTransport.get(`/services/${id}`);
    return res.data;
  },

  async createService(data) {
    const res = await errorTrackingTransport.post("/services", data);
    return res.data;
  },

  async updateService(id, data) {
    const res = await errorTrackingTransport.patch(`/services/${id}`, data);
    return res.data;
  },

  async deleteService(id) {
    const res = await errorTrackingTransport.delete(`/services/${id}`);
    return res.data;
  },

  // View Results (only results go through error-logging-service; view CRUD uses ViewsServiceV2)
  async getViewResults(serviceId, viewId, params = {}) {
    const res = await errorTrackingTransport.get(
      `/services/${serviceId}/issues/views/${viewId}/results`,
      { params },
    );
    return res.data;
  },

  // Issues
  async listIssues(serviceId, params = {}) {
    const res = await errorTrackingTransport.get(
      `/services/${serviceId}/issues`,
      { params },
    );
    return res.data;
  },

  async getIssue(issueId) {
    const res = await errorTrackingTransport.get(`/issues/${issueId}`);
    return res.data;
  },

  async updateIssueStatus(issueId, status) {
    const res = await errorTrackingTransport.patch(
      `/issues/${issueId}/status`,
      { status },
    );
    return res.data;
  },

  // Events
  async listEvents(issueId, params = {}) {
    const res = await errorTrackingTransport.get(
      `/issues/${issueId}/events`,
      { params },
    );
    return res.data;
  },

  async getEvent(eventId) {
    const res = await errorTrackingTransport.get(`/events/${eventId}`);
    return res.data;
  },

  async getLatestEvent(issueId) {
    const res = await errorTrackingTransport.get(`/issues/${issueId}/latest-event`);
    return res.data;
  },

  async getIssueTrends(issueId, params = {}) {
    const res = await errorTrackingTransport.get(`/issues/${issueId}/trends`, { params });
    return res.data;
  },

  // API Keys
  async listApiKeys(serviceId) {
    const res = await errorTrackingTransport.get(
      `/services/${serviceId}/api-keys`,
    );
    return res.data;
  },

  async createApiKey(serviceId, data) {
    const res = await errorTrackingTransport.post(
      `/services/${serviceId}/api-keys`,
      data,
    );
    return res.data;
  },

  async revokeApiKey(serviceId, keyId) {
    const res = await errorTrackingTransport.delete(
      `/services/${serviceId}/api-keys/${keyId}`,
    );
    return res.data;
  },

  // Alert Integrations
  async listAlerts(serviceId) {
    const res = await errorTrackingTransport.get(`/services/${serviceId}/alerts`);
    return res.data;
  },

  async getAlert(alertId) {
    const res = await errorTrackingTransport.get(`/alerts/${alertId}`);
    return res.data;
  },

  async createAlert(serviceId, data) {
    const res = await errorTrackingTransport.post(`/services/${serviceId}/alerts`, data);
    return res.data;
  },

  async updateAlert(alertId, data) {
    const res = await errorTrackingTransport.put(`/alerts/${alertId}`, data);
    return res.data;
  },

  async deleteAlert(alertId) {
    const res = await errorTrackingTransport.delete(`/alerts/${alertId}`);
    return res.data;
  },

  async testAlert(alertId) {
    const res = await errorTrackingTransport.post(`/alerts/${alertId}/test`);
    return res.data;
  },

  async getAlertLogs(alertId, params = {}) {
    const res = await errorTrackingTransport.get(`/alerts/${alertId}/logs`, { params });
    return res.data;
  },

  async snoozeIssue(alertId, issueId, data) {
    const res = await errorTrackingTransport.post(
      `/alerts/${alertId}/issues/${issueId}/snooze`,
      data,
    );
    return res.data;
  },

  async unsnoozeIssue(alertId, issueId) {
    const res = await errorTrackingTransport.delete(
      `/alerts/${alertId}/issues/${issueId}/snooze`,
    );
    return res.data;
  },
};
